/**
 * QuickChatRecentChoiceModal – ask to continue a recent chat or create a new one.
 */

import Modal from "@/common/components/atom/modal";
import { SettingsButton } from "@/common/components/settings/settingsList";
import QuickChatIcon from "./QuickChatIcon";
import { getQuickChatTicketTitle } from "../utils/quickChatRecent";

function getUserDisplayName(user) {
  return user?.full_name || user?.name || "بدون نام";
}

export default function QuickChatRecentChoiceModal({
  isOpen,
  onClose,
  user,
  recentTicket,
  onContinue,
  onCreateNew,
  creating = false,
}) {
  if (!isOpen || !user?.remote_id || !recentTicket?.id) return null;

  const displayName = getUserDisplayName(user);
  const ticketTitle = getQuickChatTicketTitle(recentTicket);

  return (
    <Modal name="quick-chat-recent"
      isOpen
      onClose={onClose}
      dismissible={!creating}
      title={
        <span className="inline-flex items-center gap-2 text-primary">
          <QuickChatIcon size={18} />
          <span id="quick-chat-choice-title" className="text-[0.9375rem] font-medium leading-[1.4] text-slate-900">
            گفت‌وگوی سریع با {displayName}
          </span>
        </span>
      }
    >
      <div dir="rtl" role="dialog" aria-modal="true" aria-labelledby="quick-chat-choice-title">
        <p className="m-0 text-[15px] leading-7 text-[#222]">
          شما گفت‌وگوی قبلی با عنوان «
          <strong className="font-medium">{ticketTitle}</strong>
          » دارید. مایلید همان گفت‌وگو را ادامه دهید یا گفت‌وگوی جدید بسازید؟
        </p>

        <div className="mt-4 flex flex-col gap-1">
          <SettingsButton onClick={() => onContinue?.(recentTicket.id)} disabled={creating}>
            ادامه همان گفت‌وگو
          </SettingsButton>
          <SettingsButton variant="plain" onClick={onCreateNew} loading={creating}>
            گفت‌وگوی جدید
          </SettingsButton>
        </div>
      </div>
    </Modal>
  );
}
